<template>
	<div class="realdata">
		<div class="flex">
			<div class="title" @mouseenter="enter" @mouseleave="leave">
				实时数据
				<i class="el-icon-warning"></i>
				<div :class="classes">
					<p>
						<span>正在咨询人数</span>当前正在咨询的访客数量
					</p>

					<p>
						<span>正在等待人数</span>当前处于排队状态的访客数量
					</p>
					<p>
						<span>今日平均排队时长</span>今日累计开始排队到进入咨询的平均排队时间
					</p>
					<p>
						<span>今日接待量</span>本日累计的会话数量
					</p>
					<p>
						<span>平均会话时长</span>访客进入到会话结束时间间隔的平均值
					</p>
					<p>
						<span>平均首次响应时长</span>访客第一句和坐席回复的间隔平均值
					</p>
					<p>
						<span>今日排队失败量</span>访客排队超时的人数
					</p>
					<p>
						<span>接入率</span>今日排队与排队失败的比值
					</p>
					<p>
						<span>相对满意度</span>今日累计满意数量与评价总量的比值
					</p>
					<p>
						<span>参评率</span>今日参加评价的数量与接入会话数量的比值
					</p>
				</div>
			</div>
			<div style="float:right"></div>
			<div style="float: right;width:275px;">
				<el-select v-model="value1" multiple placeholder="请选择客服" style="width:200px">
					<el-option
						v-for="(item,index) in options"
						:key="index"
						:label="item.nickName"
						:value="item.userId"
					></el-option>
				</el-select>
				<el-button type="primary" icon="el-icon-search" @click="dynamic"></el-button>
			</div>
			<div style="float: right;width:150px;margin-right:20px;width:200px">
				<el-select v-model="value2" multiple placeholder="请选择分组" @change="Select">
					<el-option
						v-for="(item,index) in option2"
						:key="index"
						:label="item.groupName"
						:value="item.groupId"
					></el-option>
				</el-select>
			</div>
			<div class="clear"></div>
		</div>
		<div class="flex-box" style="margin-top:20px;     margin-left: -15px;">
			<div class="m-ValueBox">
				<div class="m-ValueBox-top">
					<div title="接入会话量">正在咨询人数</div>
					<div title="0">{{userHead.currentConsultants}}</div>
				</div>
				<div class="m-ValueBox-bottom">
					<div title="回复率 --">
						<div class="layout" v-if="userHead.userStateEaches.length>0">
							<div>{{userHead.userStateEaches[0].name}}:{{userHead.userStateEaches[0].count}}</div>
							<div>{{userHead.userStateEaches[1].name}}:{{userHead.userStateEaches[1].count}}</div>
							<div>{{userHead.userStateEaches[2].name}}:{{userHead.userStateEaches[2].count}}</div>
							<div>{{userHead.userStateEaches[3].name}}:{{userHead.userStateEaches[3].count}}</div>
						</div>
						<div class="layout" v-if="userHead.userStateEaches.length>0 && userHead.signinCount.length>0">
							<div>{{userHead.userStateEaches[4].name}}:{{userHead.userStateEaches[4].count}}</div>
							<div>{{userHead.userStateEaches[5].name}}:{{userHead.userStateEaches[5].count}}</div>
							<div>{{userHead.signinCount[0].name}}:{{userHead.signinCount[0].count}}</div>
							<div>{{userHead.signinCount[1].name}}:{{userHead.signinCount[1].count}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="m-ValueBox">
				<div class="m-ValueBox-top">
					<div title="接入会话量">正在等待人数</div>
					<div title="0">{{userHead.currentQueue}}</div>
				</div>
				<div class="m-ValueBox-bottom">
					<div title="回复率 --">
						今日平均排队时长
						<span>{{convertMin(userHead.todayQueueVM.avgQueuingTime)}}</span>
					</div>
					<div title="转接量 0">
						今日排队总数
						<span>{{userHead.todayQueueVM.queueCount}}</span>
					</div>
					<!-- <div title>
						排队接入率
						<span>{{userHead.todayQueueVM.accessRate}}%</span>
					</div>-->
				</div>
			</div>
			<div class="m-ValueBox">
				<div class="m-ValueBox-top">
					<div title="接入会话量">今日接待量</div>
					<div title="0">{{userHead.conversationTodayVM.conversationVolumeToday}}</div>
				</div>
				<div class="m-ValueBox-bottom">
					<div title="回复率 --">
						今日平均会话时长:
						<span>{{convertMin(userHead.conversationTodayVM.averageConversation)}}</span>
					</div>
					<div title="今日平均响应时长">
						今日平均响应时长:
						<span>{{convertMin(userHead.conversationTodayVM.averageResponse)}}</span>
					</div>
					<div title="平均首次响应时长">
						平均首次响应时长:
						<span>{{convertMin(userHead.conversationTodayVM.firstResponseTime)}}</span>
					</div>
				</div>
			</div>

			<div class="m-ValueBox">
				<div class="m-ValueBox-top">
					<div title="接入会话量">今日排队失败量</div>
					<div title="0">{{userHead.todayQueueVM.failedQueueCount}}</div>
				</div>
				<div class="m-ValueBox-bottom">
					<div title="回复率">
						接入率
						<span>{{userHead.todayQueueVM.accessRate}}%</span>
					</div>
				</div>
			</div>
			<div class="m-ValueBox">
				<div class="m-ValueBox-top">
					<div title="接入会话量">今日相对满意度</div>
					<div title="0">{{userHead.satisfactionDegree.satisfactionDegree}}%</div>
				</div>
				<div class="m-ValueBox-bottom">
					<div title="回复率">参评率{{userHead.satisfactionDegree.participationRate}}%</div>
				</div>
			</div>
		</div>
		<div class="m-echart">
			<div class="m-echart-title">
				<div>
					<span class="m-echart-titleTxt">今日在线服务数据趋势</span>
				</div>
			</div>
			<div id="main-1" style="width:100%;height:420px;"></div>
		</div>
		<div class="m-echart">
			<div class="m-echart-title">
				<div>
					<span class="m-echart-titleTxt">今日客服活动</span>
					<div>
						<el-input placeholder="输入客服姓名搜索" v-model="nickname" style="float: right;">
							<el-button slot="append" icon="el-icon-search" @click="getUserTable"></el-button>
						</el-input>
					</div>
				</div>
			</div>
		</div>
		<div style="padding-right:15px" class>
			<!-- style="width: 1100px" -->
			<el-table :data="userTable" :default-sort="{prop: 'currentName', order: 'descending'}">
				<el-table-column prop="nickName" label="客服"></el-table-column>
				<el-table-column label="在线状态" prop="onLine">
					<template slot-scope="scope">{{scope.row.onLine==true?"在线":"离线"}}</template>
				</el-table-column>
				<el-table-column prop="currentName" width="100px" label="客服状态" sortable></el-table-column>
				<el-table-column prop="currentSessionCount" label="当前接待人数"></el-table-column>
				<el-table-column prop="accessChatCount" label="累计接待人数"></el-table-column>
				<el-table-column prop="messageCount" label="累计会话量"></el-table-column>
				<el-table-column prop="firstResponse" label="平均首次响应时长">
					<template slot-scope="scope">{{secondToDate(scope.row.firstResponse)}}</template>
				</el-table-column>
				<el-table-column prop="avgResponse" label="平均响应时长">
					<template slot-scope="scope">{{secondToDate(scope.row.avgResponse)}}</template>
				</el-table-column>
				<el-table-column prop="praiseRatio" label="相对满意度">
					<template slot-scope="scope">{{getRatio(scope.row.praiseRatio)}}</template>
				</el-table-column>
				<!-- <el-table-column prop="participationRate" label="参评率">
					<template slot-scope="scope">{{getRatio(scope.row.participationRate)}}</template>
				</el-table-column>-->
				<!-- <el-table-column prop="firstOnlineTime" width="100px" label="首次在线时间">
					<template slot-scope="scope">{{getFormatTime(scope.row.firstOnlineTime)}}</template>
				</el-table-column>
				<el-table-column prop="logoutTime" width="100px" label="退出时间">
					<template slot-scope="scope">{{getFormatTime(scope.row.logoutTime)}}</template>
				</el-table-column>-->
				<el-table-column label="累计在线时长" width="100px">
					<template slot-scope="scope">{{secondToDate(scope.row.loginTime)}}</template>
				</el-table-column>
				<el-table-column label="累计就绪时长" width="100px">
					<template slot-scope="scope">{{secondToDate(scope.row.moveInTime)}}</template>
				</el-table-column>
				<!-- <el-table-column label="就绪占比">
					<template slot-scope="scope">{{getRatio(scope.row.moveInTimeRatio)}}</template>
				</el-table-column>-->
				<el-table-column label="累计未就绪时长" width="100px">
					<template slot-scope="scope">{{secondToDate(scope.row.moveOutTime)}}</template>
				</el-table-column>
				<el-table-column label="累计小休时长" width="100px">
					<template slot-scope="scope">{{secondToDate(scope.row.restTime)}}</template>
				</el-table-column>
				<el-table-column label="累计培训时长" width="100px">
					<template slot-scope="scope">{{secondToDate(scope.row.cultivate)}}</template>
				</el-table-column>
				<el-table-column label="累计用餐时长">
					<template slot-scope="scope">{{secondToDate(scope.row.haveMeals)}}</template>
				</el-table-column>
				<el-table-column label="挂起时长" width="100px">
					<template slot-scope="scope">{{secondToDate(scope.row.hangUp)}}</template>
				</el-table-column>
				<!-- <el-table-column label="未就绪占比">
					<template slot-scope="scope">{{getRatio(scope.row.moveOutTimeRatio)}}</template>
				</el-table-column>-->
				<!--
				<el-table-column label="挂起占比">
					<template slot-scope="scope">{{getRatio(scope.row.hangUpRatio)}}</template>
				</el-table-column>
				
				<el-table-column label="小休占比">
					<template slot-scope="scope">{{getRatio(scope.row.restTimeRatio)}}</template>
				</el-table-column>
			
				<el-table-column label="培训占比">
					<template slot-scope="scope">{{getRatio(scope.row.cultivateRatio)}}</template>
				</el-table-column>
		
				<el-table-column label="用餐占比">
					<template slot-scope="scope">{{getRatio(scope.row.haveMealsRatio)}}</template>
				</el-table-column>-->
			</el-table>
		</div>
		<div class="pagination">
			<el-pagination
				@current-change="handleCurrentChange"
				:page-size="pagination.pageSize"
				:current-page.sync="pagination.pageIndex"
				background
				layout="total, prev, pager, next"
				:total="pagination.total"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import { DateTime } from '@/utils/common'
import { FormatTimes, formatDuring } from '@/utils/FormatTime'
export default {
	name: 'realdata',
	props: [],
	data() {
		return {
			value1: [],
			value2: [],
			options: [
				{
					value: '选项1',
					label: '所有客服组',
				},
				{
					value: '选项2',
					label: '所有客服组',
				},
			],
			option2: [
				{
					value: '选项1',
					label: '所有客服组',
				},
				{
					value: '选项2',
					label: '所有客服组',
				},
			],
			tableData: [
				{
					id: 0,
					enter_time: '15:30:12',
					start_time: '15:30:12',
					end_time: '15:30:12',
					customer: '001',
					ename: '王小虎',
					sort: '无效会话',
					follow: '客服1',
					channel: '雀巢',
					session: '客服',
				},
				{
					id: 0,
					enter_time: '15:30:12',
					start_time: '15:30:12',
					end_time: '15:30:12',
					customer: '001',
					ename: '王小虎',
					sort: '无效会话',
					follow: '客服1',
					channel: '雀巢',
					session: '客服',
				},

				{
					id: 0,
					enter_time: '15:30:12',
					start_time: '15:30:12',
					end_time: '15:30:12',
					customer: '001',
					ename: '王小虎',
					sort: '无效会话',
					follow: '客服1',
					channel: '雀巢',
					session: '客服',
				},
			],
			classes: 'flex-dialog',
			userHead: {
				currentConsultants: 0,
				currentQueue: 0,
				signinCount: [
					{
						name: '',
						count: 0,
					},
					{
						name: '',
						count: 0,
					},
				],
				userStateEaches: [
					{
						id: 1,
						name: '',
						count: 0,
					},
					{
						id: 2,
						name: '',
						count: 0,
					},
					{
						id: 3,
						name: '',
						count: 0,
					},
					{
						id: 4,
						name: '',
						count: 0,
					},
					{
						id: 5,
						name: '',
						count: 0,
					},
					{
						id: 9,
						name: '',
						count: 0,
					},
				],
				conversationTodayVM: {
					conversationVolumeToday: 0,
					averageConversation: 0,
					averageResponse: 0,
					firstResponseTime: 0,
				},
				todayQueueVM: {
					failedQueueCount: 0,
					accessRate: 0,
					queueCount: 0,
				},
				satisfactionDegree: {
					satisfactionDegree: 0,
					participationRate: 0,
				},
			},
			pagination: {
				pageIndex: 1,
				pageSize: 10,
				total: 10,
			},
			userTable: [],
			getHeadLoading: false,
			getCenterLoading: false,
			getUserTableLoading: false,
			timer: null,
			nickname: '',
		}
	},
	watch: {
		value1: function (val) {},
		value2: function (val) {
			
			// this.dynamic()
			this.getUserId()
			this.getHead()
		},
	},
	mounted: function () {
		let vm = this
		// this.drawChart()
		this.dynamic()
		this.getGroup()
		this.timer = setInterval(function () {
			vm.dynamic()
		}, 20000)
	},
	beforeDestroy() {
		clearInterval(this.timer)
	},
	methods: {
		dynamic() {
			let vm = this
			if (
				vm.getHeadLoading &&
				vm.getCenterLoading &&
				vm.getUserTableLoading
			) {
				return
			}
			vm.getHeadLoading = true
			vm.getCenterLoading = true
			vm.getUserTableLoading = true
			this.getHead()
			this.getCenter()
			this.getUserTable()
		},
		getGroup() {
			let vm = this
			//分组下拉框
			this.axios
				.get('RealTimeStatistics/GetGroup', {
					headers: {
						'Content-Type': 'application/json',
					},
				})
				.then(function ({ data }) {
					if (data.result) {
						vm.option2 = data.data
					}
				})
		},
		getUserId() {
			let vm = this
			vm.axios
				.post(
					'RealTimeStatistics/GetUser',
					{ groupId: vm.groupId },
					{
						headers: {
							'Content-Type': 'application/json',
						},
					}
				)
				.then(function (data) {
					vm.options = []
					vm.options = data.data.data
				})
		},
		getHead() {
			let vm = this
			this.axios
				.post('RealTimeStatistics/GetHead', vm.getWhere(), {
					headers: {
						'Content-type': 'application/json',
					},
				})
				.then(function ({ data }) {
					vm.userHead = data.data
					console.debug(data)
					vm.getHeadLoading = false
				})
		},
		getCenter() {
			let myChart1 = this.$echarts.init(document.getElementById('main-1'))
			let vm = this
			this.axios
				.post('RealTimeStatistics/GetCenter', vm.getWhere())
				.then(function ({ data }) {
					if (data.result) {
						let option1 = {
							tooltip: {
								trigger: 'axis',
							},
							legend: {
								data: [
									data.data.access.name,
									data.data.lineUp.name,
									data.data.queueFail.name,
								],
								x: 'center', //可设定图例在左、右、居中
								y: 'bottom',
							},
							toolbox: {
								show: false,
								feature: {
									mark: { show: true },
									dataView: { show: true, readOnly: false },
									magicType: {
										show: true,
										type: ['line', 'bar', 'stack', 'tiled'],
									},
									restore: { show: true },
									saveAsImage: { show: true },
								},
							},
							calculable: true,
							xAxis: [
								{
									type: 'category',
									boundaryGap: false,
									data: data.data.access.list.map(
										(d) => d.time
									),
								},
							],
							yAxis: [
								{
									type: 'value',
								},
							],
							series: [
								{
									name: data.data.access.name,
									type: 'line',
									stack: '1',
									data: data.data.access.list.map(
										(d) => d.count
									),
								},
								{
									name: data.data.lineUp.name,
									type: 'line',
									stack: '2',
									data: data.data.lineUp.list.map(
										(d) => d.count
									),
								},
								{
									name: data.data.queueFail.name,
									type: 'line',
									stack: '3',
									data: data.data.queueFail.list.map(
										(d) => d.count
									),
								},
							],
						}
						myChart1.setOption(option1)
						vm.getCenterLoading = false
					}
				})
		},
		getWhere() {
			let vm = this
			let obj = {}
			var ChannelIdModel = []
			vm.option2.forEach((element) => {
				vm.value2.forEach((element1) => {
					if (element1 == element.groupId) {
						element.channelList.forEach((element2) => {
							ChannelIdModel.push(element2)
						})
					}
				})
			})

			obj.groupId = new Set(vm.value2)
			obj.userId = new Set(vm.value1)
			obj.channelId = new Set(ChannelIdModel)
			return obj
		},
		enter() {
			this.classes = 'flex-dialog on'
		},
		leave() {
			this.classes = 'flex-dialog'
		},
		//通过分组出来客服得下拉框
		Select() {
			let $this = this

			// console.log(ChannelIdModel)
			// console.log($this.option2)
			if ($this.value2.length > 0) {
				var groupId = {
					GroupId: $this.value2,
				}

				$this.axios
					.post('RealTimeStatistics/GetUser', groupId, {
						headers: {
							'Content-Type': 'application/json',
						},
					})
					.then(function (data) {
						$this.options = []
						$this.options = data.data.data
					})
			} else {
				$this.options = []
			}
		},
		handleCurrentChange() {
			this.getUserTable()
		},
		getUserTable() {
			let vm = this
			var obj = new Object()
			obj.statistics = vm.getWhere()
			obj.pagination = vm.pagination
			if (vm.nickname != '' && vm.nickname != undefined) {
				obj.statistics.RealName = vm.nickname
			}
			this.axios
				.post('RealTimeStatistics/ReturnRealTimesUserForm', obj)
				.then(function ({ data }) {
					if (data.result) {
						console.log(data)
						vm.userTable = data.data.list
						vm.pagination = data.data.pagination
					}
					vm.getUserTableLoading = false
				})
		},
		//下拉框客服
		Select_User() {
			// this.drawChart()
		},
		convertMin(ss) {
			//转换
			let dateTime = new DateTime()
			return dateTime.convertSSAndMin(ss)
		},
		secondToDate: function (msd) {
			if (msd == null || msd == undefined || msd == 0) {
				return '--'
			}
			var time = msd
			return formatDuring(time)
		},
		getFormatTime(val) {
			if (val == undefined || val == null || val == 0) {
				return '--'
			}
			return FormatTimes(val, 'hh:mm:ss')
		},
		getRatio(val) {
			if (val == undefined || val == null || val == 0) {
				return '--'
			} else {
				return val + '%'
			}
		},
	},
}
</script>

<style scoped>
.system .flex {
	padding: 30px 0 10px 0;
}
.system .title {
	font-size: 22px;
	float: left;
	position: relative;
}
.flex-dialog {
	display: none;
	position: absolute;
	width: 800px;
	padding: 30px;
	min-height: 100px;
	background-color: #fff;
	top: 25px;
	left: 64px;
	box-shadow: 0 0 4px #ddd;
}
.flex-dialog.on {
	display: block;
}
.flex-dialog p {
	white-space: nowrap;
	line-height: 28px;
	font-size: 14px;
	color: #333;
}
.flex-dialog p span {
	display: inline-block;
	width: 125px;
}
.system .flex-box {
	width: 100%;
	display: flex;
	display: -webkit-flex;
	align-items: flex-start;
	justify-content: center;
	min-height: 200px;
}
.system .flex-box .m-ValueBox {
	flex: 1;
	border: 1px solid #ddd;
	margin-left: 20px;
	text-align: center;
}
.system .m-ValueBox-top {
	padding-top: 18px;
	padding-bottom: 15px;
	background-color: #fff;
}
.system .m-ValueBox-top > div:nth-child(2) {
	font-size: 30px;
	min-height: 45px;
	color: #337eff;
	margin-top: 10px;
	white-space: nowrap;
	text-align: center;
}
.system .m-ValueBox-bottom {
	display: -webkit-box;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	flex-direction: column;
	justify-content: space-around;
	height: 90px;
	border-top: 1px solid #ddd;
}
.m-echart {
	margin-top: 30px;
}
.m-echart-titleTxt {
	font-size: 22px;
}
.m-echart-title {
	margin-bottom: 10px;
}

.table_box /deep/ .el-table__body-wrapper::-webkit-scrollbar {
	width: 10px;
	height: 10px;
}

.table_box /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
	background-color: #ddd;
	border-radius: 3px;
	cursor: pointer;
	/* border-radius: 10px;
	background-color: skyblue;
	cursor: pointer;
	background-image: -webkit-linear-gradient(
		45deg,
		rgba(255, 255, 255, 0.2) 25%,
		transparent 25%,
		transparent 50%,
		rgba(255, 255, 255, 0.2) 50%,
		rgba(255, 255, 255, 0.2) 75%,
		transparent 75%,
		transparent
	); */
}
.table_box /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
	background-color: #ccc;
}
.pagination {
	text-align: right;
	width: 100%;
}
.el-pagination {
	text-align: right;
	margin-top: 50px;
	display: inline-block;
	padding-bottom: 50px;
}
.el-button {
	/* background-color: #fafafa; */
}
.realdata .el-input-group {
	width: 230px;
	margin-right: 20px;
}
.realdata .el-input__icon {
	line-height: 32px;
}
.layout {
	display: flex;
	display: -webkit-flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 15px;
}
.layout > div {
	flex: 1;
}
</style>


<style >
::-webkit-scrollbar {
	width: 10px;
	height: 10px;
}

::-webkit-scrollbar-thumb {
	background-color: #ddd;
	border-radius: 5px;
	cursor: pointer;
}
::-webkit-scrollbar-thumb:hover {
	background-color: #ccc;
}
</style>


// WEBPACK FOOTER //
// src/components/manage/system/realdata.vue